//@ts-ignore
import { useEffect, useState } from "react"
import eyuiTheme from "../theme"

/**
 * @returns {boolean}
 */
export default function useIsWide() {
  const [isWideScreen, setIsWideScreen] = useState(false)
  useEffect(() => {
    calculateAndUpdateState()
    window.addEventListener("resize", calculateAndUpdateState)
    return () => {
      window.removeEventListener("resize", calculateAndUpdateState)
    }
  }, [])

  function calculateAndUpdateState() {
    setIsWideScreen(window["innerWidth"] >= eyuiTheme.breakpoints.values.sm)
  }

  return isWideScreen
}
